import { render, staticRenderFns } from "./AddEditEventPromotion.vue?vue&type=template&id=1efb5838"
import script from "./AddEditEventPromotion.vue?vue&type=script&lang=js"
export * from "./AddEditEventPromotion.vue?vue&type=script&lang=js"
import style0 from "./AddEditEventPromotion.vue?vue&type=style&index=0&id=1efb5838&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports